// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"286":"85475233","473":"345fa5f7","547":"3ffe5068","615":"7eb018a6"}[chunkId] + ".chunk.css";
};